module.exports = __webpack_public_path__ + "static/media/ic_right.f7df6c39.svg";